<template>
  <div v-if="model && !model.$disabled">
    <label>
      {{ model.$title }}
    </label>

    <div v-for="(partner, partnerIndex) in model.$items" :key="'partner_' + partnerIndex" class="partner panel p-3">
      <div class="panel-hdr">
        <label>
          <h1>Wspólnik {{ partnerIndex + 1 }}</h1>
        </label>

        <div class="ml-auto">
          <w-row-buttons
            :model="partner.$item"
            :move-up="partnerIndex != 0"
            :move-down="partner.$item.$parent.$value.length - 1 !== partnerIndex"
          />
        </div>
      </div>

      <div class="panel-container">
        <div class="row">
          <gender-radio :model="partner.$item.gender" class="col" />
        </div>

        <div class="row">
          <w-input :model="partner.$item.firstName" class="col-xl-4 col-md-6 mt-4" />

          <w-input :model="partner.$item.lastName" class="col-xl-4 col-md-6 mt-4" />

          <w-input :model="partner.$item.nip" class="col-xl-4 col-md-6 mt-4" />
        </div>

        <div class="row">
          <w-input :model="partner.$item.workplaceName" class="col-xl-8 col-md-12 mt-4" />
        </div>

        <w-address-picker class="mt-4" :model="partner.$item.address" />
      </div>
    </div>

    <div>
      <w-error :model="model" />

      <w-add-row class="float-right" :model="model">
        Dodaj wspólnika
      </w-add-row>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import GenderRadio from '@/components/forms/document/Gender.vue';

// @vuese
// Lista do dodawania wspólników
export default {
  components: {
    ...components,
    GenderRadio
  },
  props: {
    // Model danych
    model: { type: Object }
  }
};
</script>
